import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import DeepLinkSandbox from './DeepLinkSandbox/DeepLinkSandbox';
import './Sandbox.css';

const Sandbox = () => {
  const location = useLocation();

  const sandboxTools = [
    {
      path: 'deeplink',
      title: 'Deep Link Tester',
      description: 'Test and generate Marriott mobile deep links',
      component: DeepLinkSandbox
    }
    // Future sandbox tools can be added here
  ];

  const SandboxHome = () => (
    <div className="sandbox-home">
      <div className="sandbox-header">
        <h1>Development Sandbox</h1>
        <p>Testing tools and utilities for the Marriott Guest App</p>
      </div>
      
      <div className="sandbox-tools">
        <h2>Available Tools</h2>
        <div className="tools-grid">
          {sandboxTools.map((tool) => (
            <Link 
              key={tool.path} 
              to={`/sandbox/${tool.path}`} 
              className="tool-card"
            >
              <h3>{tool.title}</h3>
              <p>{tool.description}</p>
              <span className="tool-arrow">→</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="sandbox-container">
      <nav className="sandbox-nav">
        <Link to="/sandbox" className={location.pathname === '/sandbox' ? 'nav-link active' : 'nav-link'}>
          Sandbox Home
        </Link>
        {sandboxTools.map((tool) => (
          <Link 
            key={tool.path}
            to={`/sandbox/${tool.path}`} 
            className={location.pathname === `/sandbox/${tool.path}` ? 'nav-link active' : 'nav-link'}
          >
            {tool.title}
          </Link>
        ))}
      </nav>

      <div className="sandbox-content">
        <Routes>
          <Route index element={<SandboxHome />} />
          {sandboxTools.map((tool) => (
            <Route 
              key={tool.path}
              path={tool.path} 
              element={<tool.component />} 
            />
          ))}
        </Routes>
      </div>
    </div>
  );
};

export default Sandbox;
